import { get, toLower, isEmpty } from "lodash"
import { getLastRefresh } from "modules/intraday/selectors"
import { MODELS_QUERY, getModels, METADATA_GRAPHQL_QUERY } from "resources/models"
import { getRecentInstrumentsQueryUrl } from "resources/instruments"
import { getRecentInstruments } from "selectors/recentInstruments"
import { RECENT_INSTRUMENTS_RESOURCE } from "../../../sagas/app/recentInstruments"
import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { getItems, getSelectedItem, getTabs, getSelectedTab, getModelId } from "./selectors"

export default createModule({
  view,
  externalProps: (state, props) => ({
    accountId: state.global.selected.accountId,
    intradayLastRefresh: getLastRefresh(state, props),
    modelId: getModelId(state, props),
    account: state.global.selected.account,
    recentInstruments: getRecentInstruments(state, props),
  }),
  data: [{
    ...MODELS_QUERY,
    as: null,
  }, {
    resource: "unifiedSearchFavoriteFactors",
    passthrough: true,
    url: ({ accountId, modelId }) => {
      if (!modelId || !accountId) {
        return null
      }

      return {
        id: `unifiedSearchFavoriteFactors-${accountId}${modelId}`,
        url: "/api/users/me/preferences",
        payload: {
          items: [{
            type: "favoriteFactors",
            key: `${modelId}`,
            accountId,
          }],
        },
      }
    },
  }, {
    resource: "compositeAssetSecurityIds",
    as: null,
    url: ({ account, compositeAssetType, compositeAssetId, startDate, endDate, modelId, intraday, intradayLastRefresh, isExpanded }) => {
      if (!account || !compositeAssetType || !compositeAssetId || !startDate || !endDate || !modelId) {
        return null
      }

      switch (toLower(compositeAssetType)) {
        case "etf":
          return {
            id: `etfSecurityIds-${compositeAssetId}-${modelId}-${startDate}-${endDate}-${isExpanded}`,
            url: `/api/${account}/m/${modelId}/etfs/${compositeAssetId}/securities?${new URLSearchParams({ startDate, endDate, expand: isExpanded })}`,
          }
        case "index":
          return {
            id: `indexSecurityIds-${compositeAssetId}-${modelId}-${startDate}-${endDate}-${isExpanded}`,
            url: `/api/${account}/m/${modelId}/indices/${compositeAssetId}/securities?${new URLSearchParams({ startDate, endDate, expand: isExpanded })}`,
          }
        default:
          return {
            id: `resourceSecurityIds-${compositeAssetType}-${compositeAssetId}-${modelId}-${startDate}-${endDate}${intraday ? intradayLastRefresh : ""}-${isExpanded}`,
            url: `/api/${account}/m/${modelId}/r/${compositeAssetType}/${compositeAssetId}/securities?${new URLSearchParams({ startDate, endDate, intraday: intraday || false, expand: isExpanded || false })}`,
          }
      }
    },
  },
  {
    resource: "unifiedSearchModelMetadata",
    url: ({ modelId }) => {
      if (!modelId) {
        return null
      }
      return {
        id: `unifiedSearchModelMetadata-${modelId}`,
        query: METADATA_GRAPHQL_QUERY,
        variables: { modelId },
      }
    },
  }, {
    resource: RECENT_INSTRUMENTS_RESOURCE,
    url: ({ account, modelId, recentInstruments }) => isEmpty(recentInstruments) ? getRecentInstrumentsQueryUrl(account, modelId) : null,
  }],
  mapStateToProps: (state, props) => ({
    ...get(state, "modules.unifiedSearch"),
    items: getItems(state, props),
    selectedItem: getSelectedItem(state, props),
    tabs: getTabs(state, props),
    selectedTab: getSelectedTab(state, props),
    models: getModels(state, props),
    modelId: getModelId(state, props),
  }),
  actions: {
    ...Creators,
  },
})
